import { render, staticRenderFns } from "./BusinessNameDataUpdateTab.vue?vue&type=template&id=8d534eee&scoped=true&"
import script from "./BusinessNameDataUpdateTab.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateTab.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateTab.vue?vue&type=style&index=0&id=8d534eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d534eee",
  null
  
)

export default component.exports